import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class SupportService {
    openWpp(): void {
        const host = window.location.host;
        window.open(
            "https://wa.me/5511947782021?text=" +
                encodeURIComponent(`Olá sou usuário da plataforma ${host} e gostaria de uma ajuda`),
            "_blank"
        );
    }
}
